// extracted by mini-css-extract-plugin
export default {"art":"style_art__7MwhX","artImg":"style_artImg__XR1Ao","artPh":"style_artPh__jCmem"};